import { render, staticRenderFns } from "./_password.vue?vue&type=template&id=d4d71008&"
import script from "./_password.vue?vue&type=script&lang=js&"
export * from "./_password.vue?vue&type=script&lang=js&"
import style0 from "./_password.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports